import React from 'react';

export default function Masthead() {
  return (
    <header style={{ background:'rgba(244,241,234,0.72)', backdropFilter:'blur(10px)', WebkitBackdropFilter:'blur(10px)', borderBottom:'1px solid var(--border)', padding:'16px 20px 10px', textAlign:'center' }}>
      <div style={{ display:'inline-flex', alignItems:'baseline', gap:0 }}>
        <span style={{ fontFamily:"'Kaushan Script',cursive", fontSize:'clamp(32px,7vw,52px)', color:'var(--navy)', lineHeight:1 }}>
          Pardon My French
        </span>
        <span style={{ fontFamily:"'Kaushan Script',cursive", fontSize:'clamp(14px,3vw,20px)', color:'var(--red)', marginLeft:4, lineHeight:1 }}>
          Logbook
        </span>
      </div>
      <div style={{ fontFamily:"'IBM Plex Mono',monospace", fontSize:10, fontWeight:600, letterSpacing:'.18em', textTransform:'uppercase', color:'var(--slate)', marginTop:5 }}>
        S/V Pardon My French · Jeanneau SO45
      </div>
    </header>
  );
}
